export const API_ENDPOINT = process.env.VUE_APP_API
export const STORAGE_PREFIX = 'huami-sale-'
export const AUTH_LOGIN_URL = process.env.VUE_APP_LOGIN_URL
